import THREE from "three";
import * as dte from "../DtEventTypes";
import {
  BACK_ELEMENT_CLONE_OVERLAY,
  COLOR_TRACE_HIGHLIGHT_ABGR,
  ELEMENT_CLONE_OVERLAY,
  NAME_PREFIX_TRACE } from
'../facets/FacetVizEffects';

import { DtConstants } from "../schema/DtConstants";
import { HUD_LAYER } from "../hud/layers/HudLayer";
const RC = DtConstants.RC;

const EPSILON = 1e-6;
const ANIM_FPS = 30;
const ANIM_FRAME_INTERVAL = 1000 / ANIM_FPS;
const ANIM_STEPS = 100;
const CONNECTION_LINE_SPEED = 10 * 0.001;
const CONNECTION_LINE_SEGMENT_LENGTH = 5;

const CANVAS_LINE_COLOR = "rgba(127, 255, 0)";
const CANVAS_LINE_SHADOW_COLOR = "rgba(0,0,0,1.0)";
const CANVAS_LINE_STROKE_WIDTH = 2;

const CANVAS_LINE_COLOR_TRACE = "rgba(5, 91, 161)";
const CANVAS_LINE_SHADOW_COLOR_TRACE = "rgba(127, 255, 0)";
const CANVAS_LINE_STROKE_WIDTH_TRACE_SECONDARY = 2;
const CANVAS_LINE_STROKE_WIDTH_TRACE = 4;

// TODO: those a copy&paste paths from alloy svg, need to find a better way to import them as symbols
const ICON_PATHS = {
  YOU_ARE_HERE:
  'M16,12a4,4,0,1,1-4-4A4,4,0,0,1,16,12Zm6.75,0a.74.74,0,0,1-.75.75H19.91a8,8,0,0,1-7.16,7.16V22a.75.75,0,0,1-1.5,0V19.91a8,8,0,0,1-7.16-7.16H2a.75.75,0,0,1,0-1.5H4.09a8,8,0,0,1,7.16-7.16V2a.75.75,0,0,1,1.5,0V4.09a8,8,0,0,1,7.16,7.16H22A.75.75,0,0,1,22.75,12Zm-4.3,0A6.45,6.45,0,1,0,12,18.45,6.45,6.45,0,0,0,18.45,12Z',
  FLAG:
  'M22.67,14.07,17.88,3.91s0,0,0,0l-.07-.11-.1-.1s0,0,0,0a0,0,0,0,1,0,0l-.1-.06a.44.44,0,0,0-.16-.06.63.63,0,0,0-.19,0,.71.71,0,0,0-.32.07.57.57,0,0,0-.18.12l-.09.09,0,0a5,5,0,0,1-3.8,1.33A6.46,6.46,0,0,1,10,4.34a9.23,9.23,0,0,0-6.06-.9L3.72,3a.76.76,0,0,0-1-.36.75.75,0,0,0-.36,1l.42.89.06.12,4.73,10a.83.83,0,0,0,.07.13l3.49,7.4a.73.73,0,0,0,.67.43.71.71,0,0,0,.32-.07.75.75,0,0,0,.36-1L9.38,15a7.82,7.82,0,0,1,4.78.85,7.88,7.88,0,0,0,3.42.91,6.39,6.39,0,0,0,5-1.9l0,0,0,0a.56.56,0,0,0,.07-.16A.68.68,0,0,0,22.67,14.07Zm-5.09,1.21a6.45,6.45,0,0,1-2.8-.78,9.29,9.29,0,0,0-6.07-.9L4.58,4.86a7.86,7.86,0,0,1,4.79.85,7.8,7.8,0,0,0,3.42.91,7.09,7.09,0,0,0,4.15-1.18l4.15,8.78A5.49,5.49,0,0,1,17.58,15.28Z',
  FAN:
  'M17.24 7.28004C15.5891 7.33292 13.9871 7.85305 12.62 8.78004L12.49 8.69004C12.5534 7.87529 12.8798 7.1032 13.42 6.49004C13.7199 6.20674 14.0562 5.96462 14.42 5.77004C14.9109 5.5733 15.3349 5.23968 15.6416 4.80889C15.9483 4.37809 16.1247 3.86826 16.15 3.34004C16.15 2.61004 15.83 0.250042 11.8 0.250042C11.1931 0.193161 10.5811 0.270671 10.0076 0.47706C9.43405 0.68345 8.91301 1.01365 8.48151 1.44419C8.05002 1.87473 7.71866 2.39504 7.511 2.96813C7.30334 3.54122 7.22448 4.15302 7.28001 4.76004C7.33777 6.41469 7.86115 8.01949 8.79001 9.39004L8.70001 9.52004C7.88213 9.44968 7.10798 9.1204 6.49001 8.58004C6.20619 8.27824 5.96098 7.94233 5.76001 7.58004C5.56432 7.08848 5.23097 6.6638 4.79996 6.35695C4.36894 6.05009 3.85856 5.87409 3.33001 5.85004C2.60001 5.85004 0.240014 6.16004 0.240014 10.19C0.181562 10.7977 0.257901 11.4108 0.463588 11.9856C0.669275 12.5604 0.999245 13.0827 1.42997 13.5154C1.86069 13.948 2.38157 14.2803 2.95545 14.4885C3.52932 14.6968 4.14208 14.7758 4.75001 14.72C6.4041 14.6591 8.00803 14.136 9.38001 13.21L9.52001 13.3C9.44758 14.1144 9.11843 14.8848 8.58001 15.5C8.28048 15.7866 7.94421 16.0321 7.58001 16.23C7.08845 16.4257 6.66377 16.7591 6.35692 17.1901C6.05006 17.6211 5.87406 18.1315 5.85001 18.66C5.85001 19.39 6.16001 21.75 10.19 21.75C10.7977 21.8085 11.4108 21.7322 11.9856 21.5265C12.5604 21.3208 13.0827 20.9908 13.5154 20.5601C13.948 20.1294 14.2803 19.6085 14.4885 19.0346C14.6967 18.4607 14.7758 17.848 14.72 17.24C14.6634 15.5898 14.1436 13.9888 13.22 12.62L13.31 12.48C14.1221 12.5497 14.8901 12.8794 15.5 13.42C15.7833 13.72 16.0254 14.0562 16.22 14.42C16.4175 14.9124 16.7526 15.3374 17.1853 15.6442C17.6181 15.951 18.1301 16.1267 18.66 16.15C19.38 16.15 21.74 15.83 21.74 11.8C21.7985 11.1937 21.7224 10.5819 21.5172 10.0083C21.3121 9.43468 20.9828 8.91344 20.553 8.48172C20.1232 8.05001 19.6035 7.71847 19.0308 7.51075C18.4581 7.30303 17.8466 7.22426 17.24 7.28004ZM4.75001 13.22C4.34443 13.2683 3.93319 13.2239 3.54725 13.0902C3.16131 12.9565 2.81074 12.7369 2.52193 12.4481C2.23311 12.1593 2.01359 11.8087 1.87988 11.4228C1.74618 11.0369 1.70177 10.6256 1.75001 10.22C1.75001 8.93004 2.03001 7.38004 3.34001 7.38004C3.84001 7.38004 4.03001 7.62004 4.49001 8.38004C4.75986 8.86472 5.09648 9.30907 5.49001 9.70004C6.26412 10.3983 7.22826 10.8508 8.26001 11C8.26001 11.3433 8.32799 11.6832 8.46001 12C7.35983 12.7417 6.07565 13.164 4.75001 13.22ZM8.75001 4.76004C8.70177 4.35446 8.74618 3.94322 8.87988 3.55728C9.01359 3.17134 9.23311 2.82077 9.52193 2.53196C9.81074 2.24314 10.1613 2.02362 10.5473 1.88991C10.9332 1.75621 11.3444 1.7118 11.75 1.76004C13.05 1.76004 14.6 2.03004 14.6 3.35004C14.6 3.85004 14.35 4.04004 13.6 4.49004C13.1153 4.75988 12.671 5.09651 12.28 5.49004C11.5846 6.2598 11.1384 7.22196 11 8.25004C10.6571 8.25354 10.3179 8.32138 10 8.45004C9.25997 7.35651 8.83766 6.07919 8.78001 4.76004H8.75001ZM12.25 11C12.2529 11.1334 12.2291 11.266 12.18 11.39C12.1878 11.4297 12.1878 11.4704 12.18 11.51C12.0846 11.7275 11.9279 11.9124 11.7289 12.0421C11.53 12.1718 11.2975 12.2406 11.06 12.24C10.8871 12.2556 10.7129 12.2349 10.5485 12.1794C10.384 12.1238 10.2329 12.0347 10.1049 11.9176C9.97675 11.8004 9.87445 11.6579 9.80446 11.4991C9.73447 11.3403 9.69832 11.1686 9.69832 10.995C9.69832 10.8215 9.73447 10.6498 9.80446 10.491C9.87445 10.3321 9.97675 10.1896 10.1049 10.0725C10.2329 9.95539 10.384 9.86624 10.5485 9.81072C10.7129 9.7552 10.8871 9.73453 11.06 9.75004C11.2522 9.74253 11.4433 9.7813 11.6173 9.8631C11.7914 9.94489 11.9432 10.0673 12.06 10.22C12.2054 10.4529 12.272 10.7264 12.25 11ZM10.19 20.25C8.90001 20.25 7.35001 19.97 7.35001 18.66C7.35001 18.16 7.59001 17.97 8.35001 17.52C8.83204 17.2461 9.27586 16.9099 9.67001 16.52C10.382 15.7476 10.8454 14.7791 11 13.74C11.3433 13.74 11.6832 13.6721 12 13.54C12.7314 14.6401 13.1465 15.9201 13.2 17.24C13.2502 17.6473 13.2069 18.0607 13.0734 18.4488C12.9399 18.8368 12.7197 19.1893 12.4295 19.4795C12.1393 19.7697 11.7868 19.9899 11.3987 20.1234C11.0107 20.2569 10.5973 20.3002 10.19 20.25ZM18.66 14.65C18.15 14.65 17.96 14.4 17.51 13.65C17.2427 13.1637 16.9058 12.719 16.51 12.33C15.7448 11.6191 14.7829 11.1555 13.75 11C13.7479 10.656 13.6765 10.3159 13.54 10C14.6418 9.27356 15.9213 8.86206 17.24 8.81004C17.646 8.7598 18.0581 8.80282 18.4449 8.93582C18.8318 9.06882 19.1832 9.2883 19.4725 9.57756C19.7618 9.86683 19.9812 10.2183 20.1142 10.6051C20.2472 10.992 20.2903 11.4041 20.24 11.81C20.24 13.1 20 14.65 18.66 14.65Z',
  GEAR:
  'M2,8.86s0,0,0-.08a.53.53,0,0,0,0,.13S2,9,2,9ZM21.74,14.8a3.24,3.24,0,0,1-1.43-3.39,3.2,3.2,0,0,1,1.43-2.05.75.75,0,0,0,.25-1L20.14,5.19a.75.75,0,0,0-1-.3,3.25,3.25,0,0,1-2,.24,3.21,3.21,0,0,1-2.54-2.92.75.75,0,0,0-.75-.7H10.17a.74.74,0,0,0-.75.69,2.44,2.44,0,0,1-.07.46A3.17,3.17,0,0,1,8,4.68a3.24,3.24,0,0,1-2.41.45,3.7,3.7,0,0,1-.71-.23.75.75,0,0,0-1,.29L2,8.33a.72.72,0,0,0-.1.38v.07s0,.06,0,.08A.5.5,0,0,0,2,9a.58.58,0,0,0,.14.24.61.61,0,0,0,.15.12l.14.1a3.18,3.18,0,0,1,1.31,3.3A3.15,3.15,0,0,1,2.28,14.8a.75.75,0,0,0-.25,1v0L3.87,19a.75.75,0,0,0,1,.29,3.26,3.26,0,0,1,2-.24,3.21,3.21,0,0,1,2.53,2.8.75.75,0,0,0,.74.67h3.71a.76.76,0,0,0,.75-.67c0-.11,0-.22.05-.33A3.22,3.22,0,0,1,18.46,19a4.56,4.56,0,0,1,.71.24.75.75,0,0,0,1-.3L22,15.81A.75.75,0,0,0,21.74,14.8Zm-2.58,2.87a2.79,2.79,0,0,0-.39-.1A4.7,4.7,0,0,0,13.24,21H10.78a4.68,4.68,0,0,0-3.59-3.43,4.57,4.57,0,0,0-2.35.1l-1.17-2A4.69,4.69,0,0,0,5.2,13.06,4.72,4.72,0,0,0,3.66,8.51l1.19-2,.39.09A4.69,4.69,0,0,0,10.81,3h2.38a4.71,4.71,0,0,0,3.63,3.58,4.64,4.64,0,0,0,2.34-.1l1.2,2a4.7,4.7,0,0,0,0,7.1ZM12,8a4.09,4.09,0,1,0,4.09,4.09A4.1,4.1,0,0,0,12,8Zm0,6.68a2.59,2.59,0,1,1,2.59-2.59A2.6,2.6,0,0,1,12,14.67ZM2.42,9.45a.38.38,0,0,1-.13-.06.71.71,0,0,1-.35-.48.53.53,0,0,1,0-.13s0,.06,0,.08L2,9H2a.58.58,0,0,0,.14.24.61.61,0,0,0,.15.12Z',
  BOX:
  'M3.59,6.58h0l0,0ZM20.72,7a.41.41,0,0,0-.07-.17.61.61,0,0,0-.07-.1.43.43,0,0,0-.12-.11l-.05,0,0,0h0s0,0,0,0L12.4,2.79l-.08,0a.74.74,0,0,0-.72,0L3.68,6.53s0,0,0,0h0l0,0,0,0a.49.49,0,0,0-.18.2A.71.71,0,0,0,3.28,7a.69.69,0,0,0,0,.2V17.1a.75.75,0,0,0,.45.68l7.89,3.49.11.05.14.05.16,0,.17,0,.12,0h0l.1-.05,7.9-3.49a.75.75,0,0,0,.44-.68V7.21A.69.69,0,0,0,20.72,7ZM11.25,19.48l-6.5-2.87V8.36l6.5,2.88ZM12,9.93,5.81,7.18,12,4.25l6.19,2.94Zm7.24,6.68-6.5,2.87V11.24l6.5-2.88Zm1.14-10,0,0h0Z',
  SINK:
  'M3.36505 5.257768h4.51811c.194937 0 .352977-.15804.352977-.352977 0-.194938-.15804-.352977-.352977-.352977H3.36505c-.194937 0-.352977.15804-.352977.352977 0 .194938.15804.352977.352977.352977zm0-1.129527h4.51811c.194937 0 .352977-.15804.352977-.352977 0-.194938-.15804-.352978-.352977-.352978H3.36505c-.194937 0-.352977.15804-.352977.352978 0 .194937.15804.352977.352977.352977zm8.65971 1.129527c.092715 0 .184019-.03765.249437-.10354.06589-.065418.10354-.156722.10354-.249437 0-.092715-.03765-.184019-.10354-.249437-.065418-.06589-.156722-.10354-.249437-.10354-.092715 0-.184019.03765-.249437.10354-.06589.065418-.10354.156722-.10354.249437 0 .092715.03765.184019.10354.249437.065418.06589.156722.10354.249437.10354zm8.49781.800082h-5.611303c-.019437-.038404-.040333-.076384-.063912-.113423l-1.459867-2.29407a.35287.35287 0 0 0-.048193-.0601c-.724828-.724828-1.904195-.724828-2.629022 0-.353919.353918-.53455.816224-.542832 1.281072-.001883.020096-.001789.040663-.000142.061418a1.872725 1.872725 0 0 0 .04311.37218l.088574.752923H3.52695c-.69913 0-1.267894.568764-1.267894 1.267895v.21461c0 2.575322.99742 5.00696 2.808522 6.84696 1.808986 1.837835 4.220291 2.873894 6.78973 2.917333.054218.000942.107918.001365.16204.001365 2.51527-.000094 4.906103-.991395 6.747562-2.802028 1.921514-1.889275 3.023556-4.50545 3.023556-7.17824 0-.69913-.568764-1.267895-1.267894-1.267895Zm-8.49781-2.306118c.29589 0 .574741.110694.789304.312502l1.4377 2.259243c.023815.037416.042452.076714.056994.11686.003342.040239.013367.078502.029086.113752.025979.177807-.031627.36225-.167264.497887-.195173.195172-.494216.228117-.72718.07982l-2.259197-1.4377c-.136343-.144957-.229905-.319657-.277016-.508759l-.035016-.297771c.004377-.301537.12359-.584437.337306-.798153.217716-.217763.507299-.337681.815283-.337681Zm.906305 3.890798-.400183 2.876389c-.034403.24713-.248543.43355-.498074.43355-.254944 0-.469601-.190937-.499392-.444093l-.477555-4.059192zm5.340876 6.35811c-1.74498 1.715752-4.019141 2.638952-6.40268 2.598195-2.383302-.040287-4.620143-1.001561-6.298573-2.706677C3.890422 12.18497 2.965009 9.92921 2.965009 7.540355v-.21461c0-.30982.252073-.56194.56194-.56194h6.855055l.450258 3.827027c.071583.608627.587683 1.067591 1.200499 1.067591.599873 0 1.114608-.448045 1.197252-1.042224l.374956-2.695005c.051064.006165.102316.009883.153521.009883.332223 0 .66101-.129754.912611-.381356.219176-.219176.345118-.497604.37345-.785963h5.47802c.30982 0 .56194.252073.56194.562551 0 2.48416-1.02514 4.91688-2.81257 6.67433zm4.671583-12.08439H1.105996C.496145 1.91625 0 2.412395 0 3.022245v4.51811c0 3.211952 1.25081 6.231602 3.52196 8.5028 2.271198 2.27115 5.290895 3.52196 8.5028 3.52196 3.211905 0 6.231602-1.25081 8.5028-3.52196 2.27115-2.271198 3.52196-5.290848 3.52196-8.5028v-4.51811c0-.60985-.496145-1.105995-1.105996-1.105995Zm.400041 5.624105c0 3.023368-1.177344 5.86573-3.315162 8.003595-2.137866 2.137866-4.980275 3.31521-8.003643 3.31521-3.023368 0-5.86573-1.177344-8.003596-3.315162C1.8833 13.406132.705954 10.563723.705954 7.540355v-4.51811c0-.220587.179454-.40004.400042-.40004h21.837529c.220587 0 .40004.179453.40004.40004z',
  QUESTION:
  'M12,21.75A9.75,9.75,0,1,1,21.75,12,9.77,9.77,0,0,1,12,21.75Zm0-18A8.25,8.25,0,1,0,20.25,12,8.26,8.26,0,0,0,12,3.75Zm0,14a1,1,0,1,0-1-1A1,1,0,0,0,12,17.73Zm.75-4.07a1.48,1.48,0,0,1,.57-1.16l.24-.17c1.14-.85,2-1.46,2-3.41A3.37,3.37,0,0,0,12,5.59,3.36,3.36,0,0,0,8.51,9,.75.75,0,0,0,10,9a1.88,1.88,0,0,1,2-1.93,1.89,1.89,0,0,1,2,1.83c0,1.2-.29,1.41-1.36,2.2l-.25.18a3,3,0,0,0-1.17,2.36.75.75,0,0,0,1.5,0Z'
};

const SVG_STYLE = 'fill="black" stroke="transparent"';

function getIconPathForRvtCat({ model, dbId }) {
  const catId = model.myData.dbId2catId[dbId];
  switch (catId) {
    case RC.DuctTerminal:
      return `<path ${SVG_STYLE} transform="translate(2,2) scale(0.75)" d="${ICON_PATHS.FAN}"/>`;
    case RC.MechanicalEquipment:
      return `<path ${SVG_STYLE} transform="translate(1.5,1.5) scale(0.75)" d="${ICON_PATHS.GEAR}"/>`;
    case RC.PlumbingFixtures:
      return `<path ${SVG_STYLE} transform="translate(3,4) scale(0.6)" d="${ICON_PATHS.SINK}"/>`;
    default:
      return `<path ${SVG_STYLE} transform="translate(1.5,1.5) scale(0.75)" d="${ICON_PATHS.QUESTION}"/>`;
  }
}

export const COLORS = Object.freeze({
  end: '#CE5C95',
  poi: '#FFFFFF',
  start: '#61F28A'
});

export const TRACE_ELEMENT_TYPE = Object.freeze({
  START: 3,
  END: 2,
  POI: 1,
  DEFAULT: -1 // On path, but not start/end/POI
  // 0 is reserved for off-path elements (not explicitly used)
});

const tmpLine3 = new THREE.Line3();
const tmpPlane = new THREE.Plane();
const tmpVec4_1 = new THREE.Vector4();
const tmpVec4_2 = new THREE.Vector4();
const tmpFrustum = new THREE.Frustum();


export class SystemVisualizer {

  // Multiple trace steps can be added to the draw queue
  // Eg. when displaying paths for multiple systems
  #traceSteps = [];

  // Tracks element type (start/end/POI) for all traced elements
  #tracedElementTypeByModel = new Map();

  isShowing = false;

  dispose() {
    this.hud.layers.getLayer(HUD_LAYER.TRACE.id)?.clear();
    this.hud = null;
  }

  init(facility) {
    this.facility = facility;
    this.viewer = facility.viewer;
    this.hud = this.facility.getHUD();
    this.animTick = 0;
  }

  /**
   * Add draw function to HUD's draw queue to visualize connections,
   * starting from a single element and traverse down to provided depth.
   * @returns Cleanup function
   */
  canvasConnectionsWithCleanup(systemElement, depth = 1) {
    if (!depth) {
      return () => {};
    }

    const traversed = new Set().add(systemElement);
    const traversalQueue = [systemElement];

    const nodePairs = [];
    let currentDepth = 0;

    const collectEdge = (element, connection) => {
      const start = element.getCenterPoint();
      const end = connection.getCenterPoint();

      if (start && end) {
        nodePairs.push(start, end);
      }

      if (currentDepth < depth && !traversed.has(connection)) {
        traversed.add(connection);
        traversalQueue.push(connection);
      }
    };

    // Run previously queued traversal
    while (traversalQueue.length) {
      currentDepth++;

      let depthSize = traversalQueue.length;
      while (depthSize > 0) {
        depthSize--;
        const element = traversalQueue.shift();
        element.enumConnections(null, collectEdge);
      }
    }

    function drawFunc(hud, mvpMatrix) {
      tmpFrustum.setFromProjectionMatrix(mvpMatrix);

      let planeNear = tmpFrustum.planes[5];
      let clipPlaneNear = tmpPlane.copy(planeNear).applyMatrix4(mvpMatrix);

      const edges = [];
      for (let i = 0; i < nodePairs.length; i += 2) {
        // Clone to avoid changing cached coordinates
        const start = nodePairs[i].clone();
        const end = nodePairs[i + 1].clone();

        let skip = false;

        for (const plane of tmpFrustum.planes) {
          const startToPlaneDist = plane.distanceToPoint(start);
          const endToPlaneDist = plane.distanceToPoint(end);
          if (startToPlaneDist < 0 && endToPlaneDist < 0) {
            // Skip edge if both points are culled by the same plane
            skip = true;
            break;
          }
        }

        if (skip) continue;

        clipAndProject(start, end, clipPlaneNear, mvpMatrix);

        start.x = (start.x * 0.5 + 0.5) * hud.width;
        start.y = (-start.y * 0.5 + 0.5) * hud.height;

        end.x = (end.x * 0.5 + 0.5) * hud.width;
        end.y = (-end.y * 0.5 + 0.5) * hud.height;

        edges.push([start, end]);
      }

      // Sort by depth, but it makes some lines blink in and out of existence
      edges.sort((e1, e2) => e2[0].z + e2[1].z - (e1[0].z + e1[1].z));

      for (let i = 0; i < edges.length; i++) {
        drawConnectionLine(hud.ctx, hud.dpr, edges[i][0], edges[i][1]);
      }
    }

    // Push to queue and trigger canvas redraw
    const drawOrder = -1;
    // TODO: Use same pattern as canvasMultiPaths instead of hacking draw step into init
    const drawStep = [drawOrder, { init: drawFunc }];
    this.hud.addDrawStep(drawStep);

    return () => {
      this.hud.removeDrawStep(drawStep);
    };
  }


  canvasMultiPaths(filteredTracePaths) {

    //console.log("START", startElements);
    //console.log("END", endElements);

    const { nodePairs, nodePairsSecondary } = filteredTracePaths.collectEdges();

    const visualizer = this;
    let edges,lastFrameTime = 0;

    const animStep = {
      init: (hud, mvpMatrix) => {
        edges = [];

        tmpFrustum.setFromProjectionMatrix(mvpMatrix);

        let planeNear = tmpFrustum.planes[5];
        let clipPlaneNear = tmpPlane.copy(planeNear).applyMatrix4(mvpMatrix);

        // Map to store distance from root
        const distFromRoot = new Map();

        const allNodeSets = [nodePairsSecondary, nodePairs];

        for (let j = 0; j < allNodeSets.length; j++) {

          const nodePairs = allNodeSets[j];

          for (let i = 0; i < nodePairs.length; i += 2) {

            if (nodePairs[i].distanceToSquared(nodePairs[i + 1]) <= EPSILON) {
              // Skip near zero length segments
              continue;
            }

            // Clone to avoid changing cached coordinates
            const start = nodePairs[i].clone();
            const end = nodePairs[i + 1].clone();

            let skip = false;

            for (const plane of tmpFrustum.planes) {
              const startToPlaneDist = plane.distanceToPoint(start);
              const endToPlaneDist = plane.distanceToPoint(end);
              if (startToPlaneDist < 0 && endToPlaneDist < 0) {
                // Skip edge if both points are culled by the same plane
                skip = true;
                break;
              }
            }

            if (skip) continue;

            clipAndProject(start, end, clipPlaneNear, mvpMatrix);

            start.x = (start.x * 0.5 + 0.5) * hud.width;
            start.y = (-start.y * 0.5 + 0.5) * hud.height;

            end.x = (end.x * 0.5 + 0.5) * hud.width;
            end.y = (-end.y * 0.5 + 0.5) * hud.height;

            const dx = end.x - start.x;
            const dy = end.y - start.y;
            const distSq = dx * dx + dy * dy;

            if (distSq <= EPSILON) {
              // Skip near zero length projected segments
              continue;
            }

            const startHash = hash2DCoord(start.x, start.y);
            const offset = distFromRoot.get(startHash) ?? 0;
            edges.push([start, end, offset, j]);

            // Store offset value for this edge's end point
            const endHash = hash2DCoord(end.x, end.y);
            if (!distFromRoot.has(endHash)) {
              const edgeLength = dist2D(start, end);
              const endOffset = offset + edgeLength;
              distFromRoot.set(endHash, endOffset);
            }
          }
        }

        // Sort by depth
        edges.sort((e1, e2) => e2[0].z + e2[1].z - (e1[0].z + e1[1].z));
      },
      update: (ts) => {
        const delta = ts - lastFrameTime;
        if (delta > ANIM_FRAME_INTERVAL) {
          visualizer.animTick += delta * CONNECTION_LINE_SPEED;
          visualizer.animTick %= ANIM_STEPS;
          lastFrameTime = ts;
          return true;
        }
      },
      drawStatic: (hud) => {
        hud.ctx.lineCap = "butt";

        // 1- Solid background line
        hud.ctx.strokeStyle = CANVAS_LINE_SHADOW_COLOR_TRACE;

        let lastImportance = -1;
        let pathEmpty = true;
        for (const [start, end, _, importance] of edges) {

          if (lastImportance !== importance) {
            !pathEmpty && hud.ctx.stroke();
            hud.ctx.beginPath();
            if (importance === 0) {
              hud.ctx.lineWidth = CANVAS_LINE_STROKE_WIDTH_TRACE_SECONDARY * hud.dpr;
            } else {
              hud.ctx.lineWidth = CANVAS_LINE_STROKE_WIDTH_TRACE * hud.dpr;
            }
          }

          hud.ctx.moveTo(start.x, start.y);
          hud.ctx.lineTo(end.x, end.y);
          lastImportance = importance;
          pathEmpty = false;
        }
        !pathEmpty && hud.ctx.stroke();

      },
      drawAnim: (hud) => {
        const animOffset = visualizer.animTick;
        hud.animCtx.lineCap = "butt";

        // 2- Dashed high contrast animated line on top
        hud.animCtx.setLineDash([CONNECTION_LINE_SEGMENT_LENGTH * hud.dpr, CONNECTION_LINE_SEGMENT_LENGTH * hud.dpr]);
        hud.animCtx.strokeStyle = CANVAS_LINE_COLOR_TRACE;

        //Must make multple strokes here because we vary the line dash offset per segment
        //hud.animCtx.lineDashOffset = -animOffset;
        //hud.animCtx.beginPath();
        for (const [start, end, offset, importance] of edges) {

          if (importance === 0) {
            hud.animCtx.lineWidth = CANVAS_LINE_STROKE_WIDTH_TRACE_SECONDARY * hud.dpr;
          } else {
            hud.animCtx.lineWidth = CANVAS_LINE_STROKE_WIDTH_TRACE * hud.dpr;
          }

          hud.animCtx.beginPath();
          hud.animCtx.lineDashOffset = offset - animOffset;
          hud.animCtx.moveTo(start.x, start.y);
          hud.animCtx.lineTo(end.x, end.y);
          hud.animCtx.stroke();
        }
        //hud.animCtx.stroke();
      }
    };

    // Push to queue and trigger canvas redraw
    const priority = -1;
    const drawStep = [priority, animStep];
    this.#traceSteps.push(drawStep);
    this.hud.addDrawStep(drawStep);
  }

  /**
   * Draw a set of system elements as overlays.
   *
   * All elements, not in foreground will be placed in an orange (background) overlay.
   * @param {Iterable} elements System elements to place in foreground overlay.
   * @param {Iterable} elementsBackground Elements to place in background overlay.
   * @returns Cleanup function
   */
  overlayHighlight(elements, elementsBackground) {
    for (const e of elements) {
      this.facility.facetsManager.facetsEffects.addElementHighlight(e.model, e.dbId, ELEMENT_CLONE_OVERLAY);
    }
    for (const e of elementsBackground) {
      this.facility.facetsManager.facetsEffects.addElementHighlight(e.model, e.dbId, BACK_ELEMENT_CLONE_OVERLAY);
    }
  }

  clearOverlayHighlights() {
    this.facility.facetsManager.facetsEffects.clearElementsOverlay(ELEMENT_CLONE_OVERLAY);
    this.facility.facetsManager.facetsEffects.clearElementsOverlay(BACK_ELEMENT_CLONE_OVERLAY);
  }

  // DEPRECATED
  isolateStreamMarkers(elements) {

    const streamsByHost = new Map();
    const streams = this.facility.getStreamManager().getAllStreamInfosFromCache();
    for (const stream of streams) {
      if (!stream.hostElement) continue;

      const { model: hostModel, hostId } = stream.hostElement;

      let byModel = streamsByHost.get(hostModel);
      if (!byModel) {
        byModel = new Map();
        streamsByHost.set(hostModel, byModel);
      }

      let byHost = byModel.get(hostId);
      if (!byHost) {
        byHost = [];
        byModel.set(hostId, byHost);
      }

      byHost.push(stream);
    }

    const streamsTraced = [];
    for (const traceEl of elements) {
      const { model, dbId } = traceEl;

      const streams = streamsByHost?.get(model)?.get(dbId);
      streams && streamsTraced.push(...streams.map((s) => s.dbId));
    }

    const markers = this.facility.viewer.dataViz.markers;
    const defaultModelVM = this.facility.getDefaultModel().visibilityManager;

    defaultModelVM?.isolateMultiple(streamsTraced, true /* shallow */);

    markers.matchHostVisibility = false;
    markers.isActive && markers.update();
  }

  // DEPRECATED
  resetStreamMarkers() {
    const markers = this.facility.viewer.dataViz.markers;
    const defaultModelVM = this.facility.getDefaultModel().visibilityManager;

    defaultModelVM?.isolateNone();

    markers.matchHostVisibility = true;
    markers.isActive && markers.update();
  }

  highlightRoomsAlongTrace(elements) {

    const doneRooms = new Set();
    for (const e of elements) {
      const erooms = this.facility.getRoomsOfElement(e.model, e.dbId);

      for (const r of erooms) {
        const rid = r.model.id + ":" + r.dbId;
        if (doneRooms.has(rid)) {
          continue;
        }
        doneRooms.add(rid);
        this.facility.facetsManager.facetsEffects.addSpaceBoundaryViz(NAME_PREFIX_TRACE + r.dbId, r.model, r.dbId, COLOR_TRACE_HIGHLIGHT_ABGR);
      }
    }

  }

  resetRoomsAlongTrace() {
    this.facility.facetsManager.facetsEffects.removeSpacesFromOverlay((mesh) => {
      return mesh.name.startsWith(NAME_PREFIX_TRACE);
    });
  }

  showOneLabel(element) {
    const traceLayer = this.hud.layers.getLayer(HUD_LAYER.TRACE.id);
    if (traceLayer) {
      // DEPRECATED
      traceLayer.addTraceLabel(element, COLORS.start);
    } else {
      // Add a new trace metadata entry for the element
      // Mark it as a POI initially, we'll update it later once we know more about the trace.
      const byDbId = new Map().set(element.dbId, TRACE_ELEMENT_TYPE.POI);
      this.#tracedElementTypeByModel.set(element.model, byDbId);
      this.facility.viewer.dispatchEvent({
        type: dte.DT_TRACE_ELEMENTS_CHANGED_EVENT,
        tracedElementTypeByModel: this.#tracedElementTypeByModel
      });
    }

    this.isShowing = true;
  }

  showLabelsAlongTrace(filteredPaths, enableDrag) {

    const tracePaths = filteredPaths.tracePaths;
    const traceLayer = this.hud.layers.getLayer(HUD_LAYER.TRACE.id);
    for (const element of filteredPaths.elementsOnSelectedPaths) {
      const isStartElement = element === tracePaths.startElement;
      const isPoi = tracePaths.needsLabel(this.facility, element);
      const isEndElement = tracePaths.endElements.has(element);

      if (isStartElement || isPoi || isEndElement) {
        // Re-adjust according to new function/position
        let bgColor;
        let iconPath;
        if (isStartElement) {
          bgColor = COLORS.start;
        } else if (isEndElement) {
          bgColor = COLORS.end;
        } else {
          bgColor = COLORS.poi;
          iconPath = getIconPathForRvtCat(element);
        }

        const isDraggable = enableDrag && (isStartElement || isEndElement);
        traceLayer.addTraceLabel(element, bgColor, iconPath, isDraggable);
      }
    }
  }

  collectTracedElementTypes(filteredPaths) {
    const tracePaths = filteredPaths.tracePaths;

    const getHighestPriorityType = (element) => {
      if (element === tracePaths.startElement) {
        return TRACE_ELEMENT_TYPE.START;
      } else if (tracePaths.endElements.has(element)) {
        return TRACE_ELEMENT_TYPE.END;
      } else if (tracePaths.needsLabel(this.facility, element)) {
        return TRACE_ELEMENT_TYPE.POI;
      }
      return TRACE_ELEMENT_TYPE.DEFAULT;
    };

    for (const element of filteredPaths.elementsOnSelectedPaths) {
      const { model, dbId } = element;

      let byDbId = this.#tracedElementTypeByModel.get(model);
      if (!byDbId) {
        byDbId = new Map();
        this.#tracedElementTypeByModel.set(model, byDbId);
      }

      const currType = byDbId.get(dbId);
      const highestPriorityType = getHighestPriorityType(element);

      if (!currType || highestPriorityType > currType) {
        byDbId.set(dbId, highestPriorityType);
      }
    }
  }

  showTrace(filteredPaths, hasLine, hasOverlay, hasSpaces, showLabels, enableDrag) {

    this.isShowing = true;

    if (hasLine) {
      this.canvasMultiPaths(filteredPaths);
    }
    if (hasOverlay) {
      this.overlayHighlight(
        filteredPaths.elementsOnSelectedPaths,
        filteredPaths.elementsOffSelectedPaths
      );
    }
    if (hasSpaces) {
      this.highlightRoomsAlongTrace(filteredPaths.elementsOnSelectedPaths);
    }
    if (showLabels) {
      const traceLayer = this.hud.layers.getLayer(HUD_LAYER.TRACE.id);
      if (traceLayer) {
        // DEPRECATED
        this.showLabelsAlongTrace(filteredPaths, enableDrag);
      } else {
        this.collectTracedElementTypes(filteredPaths);
        this.facility.viewer.dispatchEvent({
          type: dte.DT_TRACE_ELEMENTS_CHANGED_EVENT,
          tracedElementTypeByModel: this.#tracedElementTypeByModel
        });
      }
    }
  }

  clearTrace() {

    if (!this.isShowing) {
      return;
    }

    this.clearOverlayHighlights();
    this.#traceSteps.forEach((step) => this.hud.removeDrawStep(step));
    this.#traceSteps.length = 0;
    this.resetRoomsAlongTrace();
    this.#tracedElementTypeByModel.clear();
    this.facility.viewer.dispatchEvent({
      type: dte.DT_TRACE_ELEMENTS_CHANGED_EVENT,
      tracedElementTypeByModel: this.#tracedElementTypeByModel
    });
    this.hud.layers.getLayer(HUD_LAYER.TRACE.id)?.clear();

    this.isShowing = false;
  }
}


function drawConnectionLine(ctx, dpr, start, end) {

  // Three strokes per edge
  ctx.beginPath();

  ctx.moveTo(start.x, start.y);
  ctx.lineTo(end.x, end.y);

  ctx.globalCompositeOperation = "source-over";

  // 1- Contrast line (open cap), drawn on top of existing strokes
  ctx.lineCap = "butt";
  ctx.lineWidth = (CANVAS_LINE_STROKE_WIDTH + 2) * dpr;
  ctx.strokeStyle = CANVAS_LINE_SHADOW_COLOR;
  ctx.stroke();

  // 2- Connection line, drawn on top of existing strokes
  ctx.lineCap = "round";
  ctx.lineWidth = CANVAS_LINE_STROKE_WIDTH * dpr;
  ctx.strokeStyle = CANVAS_LINE_COLOR;
  ctx.stroke();

  ctx.globalCompositeOperation = "destination-over";

  // 3- Contrast line (round cap), drawn underneath existing strokes
  ctx.lineCap = "round";
  ctx.lineWidth = (CANVAS_LINE_STROKE_WIDTH + 2) * dpr;
  ctx.strokeStyle = CANVAS_LINE_SHADOW_COLOR;
  ctx.stroke();
}

function clipAndProject(start, end, clipPlaneNear, m) {
  // Project start/end into clip space to check against near plane
  const clipSpaceStart = tmpVec4_1.copy(start).applyMatrix4(m);
  const clipSpaceEnd = tmpVec4_2.copy(end).applyMatrix4(m);

  if (clipPlaneNear.distanceToPoint(clipSpaceStart) < 0) {
    tmpLine3.set(clipSpaceEnd, clipSpaceStart);
    // Clip start
    clipPlaneNear.intersectLine(tmpLine3, start);
  } else {
    // No clipping needed, do perspective divide
    start.copy(clipSpaceStart);
    start.multiplyScalar(1.0 / clipSpaceStart.w);
  }

  if (clipPlaneNear.distanceToPoint(clipSpaceEnd) < 0) {
    tmpLine3.set(clipSpaceStart, clipSpaceEnd);
    // Clip end
    clipPlaneNear.intersectLine(tmpLine3, end);
  } else {
    // No clipping needed, do perspective divide
    end.copy(clipSpaceEnd);
    end.multiplyScalar(1.0 / clipSpaceEnd.w);
  }
}

function dist2D(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const distSq = dx * dx + dy * dy;
  return Math.sqrt(distSq);
}

const HASH_PRIME = 7927;
function hash2DCoord(x, y) {
  return x * 100 * HASH_PRIME ^ y * 100;
}